import React, { useCallback, useMemo, useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { useGridApiRef, GridActionsCellItem } from '@mui/x-data-grid';
import { DataGrid } from '../../../components/common/datagrid/ResponsiveDataGrid';
import InvoiceSplitDialog from '../../../components/chancemng/obtainorder/InvoiceSplitDialog';
import { Divider, Box, Button, Typography,CircularProgress } from '@mui/material';
import _ from 'lodash';

import { useSnackbar } from 'notistack';
import { useSelector,useDispatch } from 'react-redux';

import * as taxBillApi from '../../../lib/api/taxbill';
import { useChanceStore } from '../../../store/chanceStore'

const OrderCompanyBillListContainer = ({
  chance, 
  type,
  roUuid,
  mode,
  selectedRow,
  costs: propCosts,
  handleCancle, 
}) => {
//  alert(roUuid);
  const dispatch = useDispatch();

  const [rows, setRows] = useState([]);
  const [loading, setLoading    ] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogProps, setDialogProps] = useState({});
  const [selectedPartnerUuid, setSelectedPartnerUuid] = useState('');
  const [savedRows, setSavedRows] = useState([]);

  // 상태 조회(selector)
  const billInfList = useChanceStore(state => state.billInfList)
  const billInvList = useChanceStore(state => state.billInvList)

  // 액션 가져오기
  const setBillInfList = useChanceStore(state => state.setBillInfList)
  const setBillInvList = useChanceStore(state => state.setBillInvList)

useEffect(() => setBillInfList(rows), [rows, setBillInfList]);
useEffect(() => setBillInvList(savedRows), [savedRows, setBillInvList]);

    
  useEffect(() => {

    if (chance?.prjUuid) {
      if(mode == 'add' ) {
        loadBillInfCrt(chance?.prjUuid);
      } else {
        loadBillInfList(chance?.prjUuid, roUuid);
        loadBillInvList(chance?.prjUuid, roUuid);
      }
    }
  }, [chance?.prjUuid, roUuid])

  const getSelectedPartnerUuid = () => {
    return selectedPartnerUuid;
  };

  const loadBillInfCrt = async (id) => {
    try {
        const response = await taxBillApi.getInvoiceCrt(id);
        if (response.data.list) {
          setRows(response.data.list);

          dispatch({
            type: 'projectModule/orderAdd/SET_BILL_INF_LIST',
            payload: rows
          });
          if( mode != 'view') setBillInfList(response.data.list);
          setLoading(false);
        }
    } catch (err) {
        let message =
            typeof err.response !== 'undefined'
                ? err.response.data.message
                : err.message;
        enqueueSnackbar(message, {
            variant: 'error',
        });
    }
  }
  
  const normalizeList = (list) =>
    list.map(r => ({
      ...r,
      billAmt: Number(r.billAmt),
      billVat: Number(r.billVat),
      billTot: Number(r.billTot),
      issueReq: Number(r.issueReq),
      issueComp: Number(r.issueComp),
      collComp: Number(r.collComp),
    }));

  const loadBillInfList = async (prjUuid, roUuid) => {
    try {

        if(typeof roUuid == "undefined" || roUuid == null || roUuid == "")
          return true;

        const response = await taxBillApi.getInvoiceInfList(prjUuid,roUuid );
        if (response.data.list) {
          const normalized = normalizeList(response.data.list);
          setRows(normalized);
          dispatch({
            type: 'projectModule/orderAdd/SET_BILL_INF_LIST',
            payload: normalized
          });          
          
          setBillInfList(normalized);
          setLoading(false);
          
        }
    } catch (err) {
        let message =
            typeof err.response !== 'undefined'
                ? err.response.data.message
                : err.message;
        enqueueSnackbar(message, {
            variant: 'error',
        });
    }
  }

  
  
  const loadBillInvList = async (prjUuid, roUuid) => {
    try {

        if(typeof roUuid == "undefined" || roUuid == null || roUuid == "")
          return true;

        const response = await taxBillApi.getInvoiceInvDataList(prjUuid,roUuid );
        if (response.data.list) {

          setSavedRows(response.data.list);
          dispatch({
            type: 'projectModule/orderAdd/SET_BILL_INV_LIST',
            payload: rows
          });          
          
          if( mode != 'view') setBillInvList(response.data.list);
          setLoading(false);
          
        }
    } catch (err) {
        let message =
            typeof err.response !== 'undefined'
                ? err.response.data.message
                : err.message;
        enqueueSnackbar(message, {
            variant: 'error',
        });
    }
  }

  const handleInstallmentClick = (row) => {
    setSelectedPartnerUuid(row.partnerUuid);
    setDialogProps({
      type: row.billTyp,
      billUuid: row.billUuid,
      installmentCount: row.installment,
      // totalAmount: row?.billAmt ? (row?.billAmt - row?.issueReq) : 0,
      totalAmount: row.billAmt,
      billVat: Math.floor(row.billAmt * 0.1),      
      onSave: (updatedSplits) => {
        // ---- savedRows 업데이트 (functional update) ----
        setSavedRows(prevSaved => {
          const remaining = prevSaved.filter(
            item => item.partnerUuid !== row.partnerUuid
          );
          const newSplits = updatedSplits.map(split => ({
            ...split,
            partnerUuid: row.partnerUuid,
            issueReq: split.amt,
          }));
          const newSaved = [...remaining, ...newSplits];
          // 즉시 store 에도 반영
          // setBillInvList(newSaved);
          return newSaved;
        });
  
        // ---- rows 업데이트 (functional update) ----
        setRows(prevRows => {
          const newRows = prevRows.map(r =>
            r.partnerUuid === row.partnerUuid
              ? {
                  ...r,
                  installment: updatedSplits.length,

                  //billAmt: updatedSplits.reduce((sum, s) => sum + Number(s.invAmt), 0),
                  billVat: updatedSplits.reduce((sum, s) => sum + Number(s.invVat), 0),
                  billTot: updatedSplits.reduce((sum, s) => sum + Number(s.invTot), 0),

                  issueReq: updatedSplits
                    .filter(s => s.reqCompYn === 'N')
                    .reduce((sum, s) => sum + Number(s.invAmt), 0),
                  issueComp: updatedSplits
                    .filter(s => s.reqCompYn === 'Y')
                    .reduce((sum, s) => sum + Number(s.invAmt), 0),
                  collComp: updatedSplits
                    .filter(s => s.procCompYn === 'Y')
                    .reduce((sum, s) => sum + Number(s.invAmt), 0),
                }
              : r
          );
          // 즉시 store 에도 반영
          // setBillInfList(newRows);
          return newRows;
        });
           
        setDialogOpen(false);
      },
    });
    setDialogOpen(true);
  };

  const columns = useMemo(
    () => [
    { field: 'billTyp', headerName: '종류',
      type: 'string',
      width: 100 },
    {
      field: 'partnerUuid',
      headerName: 'partnerUuid',
      hide: true,
      type: 'string',
      editable: false,
      disableExport: true,
    },
    { field: 'partnerNm', headerName: '매출(매입)처', minWidth:200},
    {
      field: 'billAmt',
      headerName: '세금계산서금액',
      type: 'number',
      width: 150,
      valueFormatter: (params) => {
        const valueFormatted = Number(params).toLocaleString('ko-KR');
        return `₩ ${valueFormatted}`;
      },
    },
    {
      field: 'billVat',
      headerName: '부가세',
      type: 'number',
      width: 150,
      valueFormatter: (params) => {
        const valueFormatted = Number(params).toLocaleString('ko-KR');
        return `₩ ${valueFormatted}`;
      },
    },
    {
      field: 'billTot',
      headerName: '합계금액',
      type: 'number',
      width: 150,
      valueFormatter: (params) => {
        const valueFormatted = Number(params).toLocaleString('ko-KR');
        return `₩ ${valueFormatted}`;
      },
    },
    {
      field: 'installment',
      headerName: '분할',
      width: 100,
      align: 'center',
      headerAlign: 'center',      
      renderCell: (params) => (
        <Typography
        variant="body2"
        color="primary"
        sx={{ 
          cursor: 'pointer',
          textDecoration: 'underline',
          width: '100%',
          textAlign: 'center',
        }}
        onClick={() => handleInstallmentClick(params.row)}
      >
        {params.value}
      </Typography>
      ),
    },
  //   {
  //     field: 'issueReq',
  //     headerName: '발행요청금액',
  //     type: 'number',
  //     width: 200,
  //     valueFormatter: (params) => {
  //         const valueFormatted = Number(params).toLocaleString('ko-KR');
  //         return `₩ ${valueFormatted}`;
  //     },
  //   },
  //   {
  //     field: 'issueComp',
  //     headerName: '발행완료금액',
  //     type: 'number',
  //     width: 200,
  //     valueFormatter: (params) => {
  //       const valueFormatted = Number(params).toLocaleString('ko-KR');
  //       return `₩ ${valueFormatted}`;
  //   },
  // },
  //   {
  //     field: 'collComp',
  //     headerName: '수금(지급)금액',
  //     type: 'number',
  //     width: 200,
  //     valueFormatter: (params) => {
  //       const valueFormatted = Number(params).toLocaleString('ko-KR');
  //       return `₩ ${valueFormatted}`;
  //   },
  // },
  // {
  //   field: 'crtDt',
  //   headerName: '등록일자',
  //   maxWidth: 180,
  //   flex: 1,
  //   type: 'string',
  //   editable: false,
  //   align: 'center',
  //   headerAlign: 'center',
  // },
  ],
    [],
  );
  const columnVisibilityModel={
    // Hide columns status and traderName, the other columns will remain visible
    partnerUuid: false,    
  };

  return (
    <Box sx={{ height: 600, width: '100%', p: 2 }}>
      <Typography variant="h6" gutterBottom>
        매입·매출 거래 내역
      </Typography>

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <DataGrid
          rows={rows}
          columns={columns}
          pagination
          pageSize={20}
          rowsPerPageOptions={[10, 20, 50]}
          columnVisibilityModel={columnVisibilityModel? columnVisibilityModel: []}
          disableSelectionOnClick
          sx={{ '.MuiDataGrid-columnHeader': { backgroundColor: '#f5f5f5' } }}
        />
      )}

      <InvoiceSplitDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        partnerUuid={selectedPartnerUuid}
        partnerName={chance?.cstNm}
        prjUuid={chance?.prjUuid}
        roUuid={roUuid?roUuid:null}
        billrows={savedRows.filter((item) => item.partnerUuid === getSelectedPartnerUuid())}
        mode={mode}  
        {...dialogProps} 
        totalVat={dialogProps.totalVat} 
      />
    </Box>
  );
};

export default OrderCompanyBillListContainer;
